import {Component, forwardRef, ViewChild, ElementRef, OnInit, AfterViewInit} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'map-pin-selector',
  templateUrl: './map-pin-selector.component.html',
  styleUrls: ['./map-pin-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MapPinSelectorComponent),
      multi: true
    }
  ]
})
export class MapPinSelectorComponent implements AfterViewInit, ControlValueAccessor {
  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;

  map: google.maps.Map;
  marker: google.maps.Marker | null = null;
  locationLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  location: any;

  onChange: any = () => {};
  onTouched: any = () => {};

  ngAfterViewInit() {
    const mapProperties = {
      center: new google.maps.LatLng(51.509865, -0.118092),
      zoom: 10,
      mapTypeId: google.maps.MapTypeId.SATELLITE,
      streetView: null,
      streetViewControl: false
    };
    this.map = new google.maps.Map(this.gmap.nativeElement, mapProperties);

    this.map.addListener('click', (event: any) => {
      this.placeMarker(event.latLng);
    });

    if(this.location){
      this.placeMarker(this.location);
    }

  }

  writeValue(obj: any): void {
    if (obj) {
      if(obj.coordinates){
        obj = obj.coordinatesl
      }
      if(this.map){
        this.placeMarker(obj);
      }else{
        this.location = obj;
      }
    } else if (this.marker) {
      this.marker.setMap(null);
      this.marker = null;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  placeMarker(location: google.maps.LatLng) {
    if (!this.marker) {
      this.marker = new google.maps.Marker({
        position: location,
        map: this.map
      });
    } else {
      this.marker.setPosition(location);
    }
    this.onChange(location);
    this.onTouched();
  }

  resetMarker() {
    if (this.marker) {
      this.marker.setMap(null);
      this.marker = null;
      this.onChange(null);
    }
  }

  findLocation(){
    if (navigator.geolocation) {
      this.locationLoading.next(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.locationLoading.next(false);
          const currentLocation = new google.maps.LatLng(
            position.coords.latitude,
            position.coords.longitude
          );
          this.map.setCenter(currentLocation);
          this.map.setZoom(20);
          this.placeMarker(currentLocation);
        },
        () => {
          this.locationLoading.next(false);
          console.error('Error: The Geolocation service failed.');
        }
      );
    } else {
      // Browser doesn't support Geolocation
      console.error('Error: Your browser doesn\'t support geolocation.');
    }
  }
}
